export const UNKNOWN_ROOMTYPE = 'UNKNOWN'
export const OTHER_ROOMTYPE = 'OTHER'

export const UNSUPPORTED_ROOMTYPES = [UNKNOWN_ROOMTYPE, OTHER_ROOMTYPE]
